import { useState } from "react";
import { Link } from "react-router-dom";
import "./Auth.css";

import logoLight from "../../assets/images/nextskillAI_light.WebP";
import logoDark from "../../assets/images/nextskillAI_dark.WebP";

function Signup() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
  });

  const [showPass, setShowPass] = useState(false);

  const theme = document.documentElement.getAttribute("data-theme") || "dark";

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.name || !form.email || !form.password) {
      alert("Please fill all fields");
      return;
    }

    alert("Signup successful (UI only)");
  };

  const handleGoogleSignup = () => {
    alert("Google Signup (UI only)");
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        {/* LEFT PANEL */}
        <div className="auth-panel auth-panel-left">
          <Link to="/" className="auth-logo">
            <img
              src={theme === "dark" ? logoDark : logoLight}
              alt="logo"
              className="auth-logo-image"
            />
          </Link>

          <div className="auth-panel-content">
            <h1 className="auth-panel-headline">
              Start Learning Today 🚀
            </h1>

            <p className="auth-panel-sub">
              Create your account and begin your journey with practical data
              skills.
            </p>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="auth-panel auth-panel-right">
          <div className="auth-form-wrap">
            <div className="auth-form-header">
              <h2 className="auth-form-title">Create account</h2>

              <p className="auth-form-sub">
                Already have an account?{" "}
                <Link to="/login" className="auth-switch-link">
                  Log in
                </Link>
              </p>
            </div>

            {/* GOOGLE SIGNUP */}
            <button
              type="button"
              className="auth-google-btn"
              onClick={handleGoogleSignup}
            >
              <svg className="google-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
              </svg>
              Continue with Google
            </button>

            {/* DIVIDER */}
            <div className="auth-divider">
              <span>or</span>
            </div>

            <form className="auth-form" onSubmit={handleSubmit}>
              {/* NAME */}
              <div className="form-group">
                <label className="form-label">Full Name</label>

                <div className="input-wrap">
                  <input
                    type="text"
                    placeholder="Enter your name"
                    value={form.name}
                    onChange={(e) =>
                      setForm({ ...form, name: e.target.value })
                    }
                  />
                </div>
              </div>

              {/* EMAIL */}
              <div className="form-group">
                <label className="form-label">Email</label>

                <div className="input-wrap">
                  <input
                    type="email"
                    placeholder="your@email.com"
                    value={form.email}
                    onChange={(e) =>
                      setForm({ ...form, email: e.target.value })
                    }
                  />
                </div>
              </div>

              {/* PASSWORD */}
              <div className="form-group">
                <label className="form-label">Password</label>

                <div className="input-wrap">
                  <input
                    type={showPass ? "text" : "password"}
                    placeholder="Create password"
                    value={form.password}
                    onChange={(e) =>
                      setForm({ ...form, password: e.target.value })
                    }
                  />

                  <button
                    type="button"
                    className="pass-toggle"
                    onClick={() => setShowPass(!showPass)}
                  >
                    {showPass ? "🙈" : "👁"}
                  </button>
                </div>
              </div>

              <button type="submit" className="auth-submit-btn">
                Create Account →
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Signup;